import { axios } from '~/plugins/axios'

const actions = {
  async fetchInvoices() {
    const resp = await axios.get('/api/document-flow/invoices')
    return resp.data
  },

  async fetchInvoice(_, id) {
    const resp = await axios.get(`/api/document-flow/invoices/${id}`)
    return resp.data.data
  },

  async createInvoice(_, payload) {
    const resp = await axios.post('/api/document-flow/invoices', payload)
    return resp.data.data
  },

  async updateInvoice(_, { id, data }) {
    const resp = await axios.put(`/api/document-flow/invoices/${id}`, data)
    return resp.data.data
  },

  async deleteInvoice(_, id) {
    const resp = await axios.delete(`/api/document-flow/invoices/${id}`)
    return resp.data
  },

  async fetchOneCContracts() {
    const resp = await axios.get('/api/document-flow/onec-contracts')
    return resp.data.data || []
  },

  async fetchOneCContract(_, refKey) {
    const resp = await axios.get(`/api/document-flow/onec-contracts/${refKey}`)
    return resp.data.data || resp.data
  },

  async fetchOneCNomenclature() {
    const resp = await axios.get('/api/document-flow/onec-nomenclature')
    return resp.data.data || []
  },

  async fetchProjectAppendices(_, projectId) {
    const resp = await axios.get(`/api/document-flow/projects/${projectId}/appendices`)
    return resp.data.data || []
  },

  async fetchInvoiceTemplates() {
    const resp = await axios.get('/api/document-flow/invoice-templates')
    const raw = resp.data
    if (Array.isArray(raw)) {
      return raw
    }
    if (Array.isArray(raw?.data)) {
      return raw.data
    }
    return []
  },
}

export default {
  namespaced: true,
  actions,
}
